/**
 * Javascript file for the page for searching for reference projects.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import { getProjects } from "../../../../api";
export default {
  name: "ReferenceProjectSearch",

  /**
   * The vue instance's data object.
   * @property {any[]} projects - The available projects.
   * @property {any[]} searchresults - The result of the reference project search.
   * @property {string} msg - The platform's name. 
   * @property {string} searchterm - The search term for the reference project search.
   * @property {object} searchoptions - Search parameters for VueFuse. For more details, check: https://www.npmjs.com/package/vue-fuse/v/1.5.2
   * @property {string[]} searchoptions.keys - The key values for the search.
   */
  data() {
    return {
      projects: [],
      searchresults: [],
      msg: "WERNER",
      searchterm: "",
      searchoptions: {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name", "description"]
      }
    };
  },

  /**
   * Called after the instance has been mounted.
   */
  mounted() {
    let p = getProjects()
      .then(res => {
        this.projects = res;
        this.searchresults = res;
      })
      .catch(err => {
        //console.log(err);
      });
  },

  /**
   * Expressions to be watched.
   */
  watch: {
    searchterm: function () {
      if (this.searchterm != "") {
        this.search();
      } else {
        this.searchresults = this.projects;
      }
    },
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Conducts a search for a project tkaing into consideration the search term.
     */
    search() {
      this.$search(this.searchterm, this.projects, this.searchoptions).then(
        results => {
          this.searchresults = results;
        }
      );
    },

    /**
     * Shortens the description.
     * @param {*} desc - The description. 
     */
    shorten(desc) {
      var res = desc.substring(0, 500) + "...";
      return res;
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Sets a placeholder image in the element.
     * @param {*} e  - The element where the placeholder image is to be set.
     */
    setAltImg(e) {
      e.target.src = require("../../../../assets/ref-placeholder.png");
    }

  }
};



// WEBPACK FOOTER //
// ./src/components/search/referenceprojectsearch/query/referenceprojectsearch.js